// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__384gz","textarea":"styles_textarea__75zq0"};